var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7299 19.3339C24.499 20.667 23.5336 22.3333 21.9975 22.3333H2.00226C0.46322 22.3333 -0.497696 20.6644 0.269887 19.3339L10.2676 1.99938C11.0371 0.665667 12.9643 0.668083 13.7324 1.99938L23.7299 19.3339Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7299 19.3339C24.499 20.667 23.5336 22.3333 21.9975 22.3333H2.00226C0.46322 22.3333 -0.497696 20.6644 0.269887 19.3339L10.2676 1.99938C11.0371 0.665667 12.9643 0.668083 13.7324 1.99938L23.7299 19.3339ZM12 15.75C10.9415 15.75 10.0833 16.6081 10.0833 17.6667C10.0833 18.7252 10.9415 19.5833 12 19.5833C13.0585 19.5833 13.9167 18.7252 13.9167 17.6667C13.9167 16.6081 13.0585 15.75 12 15.75ZM10.1803 8.86058L10.4894 14.5273C10.5038 14.7924 10.7231 15 10.9886 15H13.0114C13.2769 15 13.4962 14.7924 13.5106 14.5273L13.8197 8.86058C13.8353 8.57417 13.6073 8.33333 13.3205 8.33333H10.6795C10.3927 8.33333 10.1647 8.57417 10.1803 8.86058Z",
    fill: "#FF7E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.ec2de7dd45018be0d4814c4dc14c0a77.svg";
export { ForwardRef as ReactComponent };